import { getConfig } from '../config';

export class ApiBase {
  private accessToken: string | null = null;

  protected getBaseUrl(defaultUrl?: string, providedUrl?: string): string {
    const configApiRoot = getConfig().api.root;
    const url = providedUrl ?? configApiRoot;
    if (url === undefined) {
      console.error(`Unable to identify a base url using provided:${providedUrl} and config:${configApiRoot} values.`);
    }
    return url ?? '';
  }

  protected transformOptions(options: RequestInit): Promise<RequestInit> {
    if (this.accessToken === null) {
      console.error('accessToken has not been set, call setAuthorization before using the client');
      throw new Error('accessToken has not been set, call setAuthorization before using the client');
    }

    const newOptions: RequestInit = {
      ...options,
      //credentials: 'include', // Allow Windows auth to work
      headers: {
        ...options.headers,
        Authorization: `Bearer ${this.accessToken}`,
      },
    };
    return Promise.resolve(newOptions);
  }

  public setAuthorization(accessToken: string) {
    this.accessToken = accessToken;
  }
}
